/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityZoneType } from '../../models/facility-zone-type';

export interface AddFacilityZoneType$Params {
      body: FacilityZoneType
}

export function addFacilityZoneType(http: HttpClient, rootUrl: string, params: AddFacilityZoneType$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityZoneType>> {
  const rb = new RequestBuilder(rootUrl, addFacilityZoneType.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityZoneType>;
    })
  );
}

addFacilityZoneType.PATH = '/api/facilityzonetype';
